import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";
import { ModalModule } from "@modules/app-modal/modal.module";
import { SharedPaymentsModule } from "@modules/+new/payments/shared-payments/shared-payments.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { ConnectToBankComponent } from "@modules/+new/payments/features/fiat-deposit/modules/bank-connector/components/connect-to-bank/connect-to-bank.component";
import { A11yModule } from "@angular/cdk/a11y";

@NgModule({
	imports: [CommonModule, CoreModule, ModalModule, SharedPaymentsModule, UniversalModalModule, A11yModule],
	declarations: [ConnectToBankComponent],
	exports: [ConnectToBankComponent]
})
export class BankConnectorModule {}
